export default __webpack_public_path__ + "static/media/avatar.d94025aa.png";